import styled from 'styled-components';
import { devices, theme } from '@/styles/theme/index.jsx';

export const StyledTeam = styled.section`
    position: relative;
    overflow: hidden;
    background: ${theme.colors.themeColor5};
    padding: 120px 0 0;
    margin-top: -1px;

    .brand-item-left {
        overflow: hidden;

        ${devices.ResponsiveTabMobile} {
            width: 50%;
        }

        .image-wrapper {
            position: relative;
            padding-top: ${theme.memberImageRatio};
            overflow: hidden;
            cursor: pointer;

            &:after {
                transition: ${theme.transition};
                ${theme.absoluteFill}
                ${theme.fullHeightWidth}
                content: '';
                background: ${theme.colors.modalImageWrapper};
            }

            .global-image {
                transition: ${theme.transition};
                transform: scale(1.01);
            }

            .content {
                position: absolute;
                left: 0;
                right: 0;
                top: 35px;
                z-index: 3;
                width: 100%;
                padding: 0 25px;
                margin: 0 auto;
                opacity: 0;
                transition: ${theme.transition};

                p {
                    ${theme.mainFont}
                    color: ${theme.colors.white};
                }


            }


            &:hover {
                .content {
                    opacity: 1;
                }

                &:after {
                    background: ${theme.colors.secondaryGreen70};

                }
            }

        }

        .info {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 40px;
            padding: 0 25px;
            z-index: 2;

            p {
                color: ${theme.colors.white};

                &:first-child {
                    margin-bottom: 8px;
                    ${theme.mainTitle}
                }

                &:last-child {
                    ${theme.designationText}
                    margin: 0;
                }

            }
        }

        margin-bottom: 30px;

        &:hover {
            .global-image {
                transition: ${theme.transition};
                transform: scale(1.05);
            }
        }

        ${devices.sm} {
            width: 50%;
            margin-bottom: 50px;
            padding: 0 25px;

            &:nth-last-of-type(-n + 2) {
                margin-bottom: 0;
            }

            .mobile-info.info {
                padding: 0;
                position: relative;
                inset: unset;
                text-align: center;
                margin-top: 20px;

                p {
                    margin-bottom: 0;

                    &:first-child {
                        font-weight: 500;
                        ${theme.mainFont500}
                        text-align: center;
                    }

                    &:last-child {
                        ${theme.mainFont13Italic}
                        text-align: center;
                    }
                }
            }

            .image-wrapper {
                &:after {
                    ${theme.displayNone}
                }
                border-radius: 50%;
                overflow: hidden;
                padding-top: ${theme.memberImageRatioMobile};


            }
        }
    }

    ${devices.sm} {
        padding: 80px 0 0;
    }
`;